import React, { Component, Fragment } from "react";
import { markdownToDraft } from "markdown-draft-js";
import PropTypes from "prop-types";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import errorsType from "../types/errorsType";
import {
  SectionTitle,
  EditorWrapper,
  Label,
  LabelText,
  Required,
  Error,
} from "../styles/edit-form-styles";

class AgencyBriefing extends Component {
  constructor(props) {
    super(props);
    this.editor = React.createRef();
    const { agencyBriefing } = this.props;

    this.state = {
      editorState: EditorState.createWithContent(
        convertFromRaw(markdownToDraft(agencyBriefing))
      ),
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    const { inputOnChange, errors } = this.props;

    return (
      <Fragment>
        <SectionTitle>Agency Briefing</SectionTitle>
        <Label>
          <LabelText>
            Agency Briefing <Required>*</Required>
          </LabelText>
        </Label>
        <EditorWrapper>
          <Editor
            ref={this.editor}
            toolbarClassName="editor-toolbar"
            editorClassName="editor"
            editorState={editorState}
            onEditorStateChange={this.onEditorStateChange}
            onChange={() => inputOnChange(editorState)}
            toolbar={{
              options: ["inline", "list"],
              inline: {
                options: ["bold", "italic", "underline", "strikethrough"],
              },
              list: {
                options: ["unordered", "ordered"],
              },
            }}
          />
          {errors.agencyBriefing && (
            <Error>{`Job agency briefing ${errors.agencyBriefing}.`}</Error>
          )}
        </EditorWrapper>
      </Fragment>
    );
  }
}

AgencyBriefing.propTypes = {
  agencyBriefing: PropTypes.string.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
};

export default AgencyBriefing;
